export default class ValidatorHelper {

  private static UUID_v4: RegExp = new RegExp(/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i)

  public static isValidUUIDv4(uuid: string): boolean {
    if (uuid === undefined) return false
    return this.UUID_v4.test(uuid);
  }
}
